<template>
    <div class="page">
      <h1>主播授权协议</h1>
      <p class="content xieyi-wrap">
        <img class="xieyi" src="@/assets/171606188304_.pic_hd.jpg" />
        <img class="xieyi" src="@/assets/181606188304_.pic_hd.jpg" />
        <img class="xieyi" src="@/assets/191606188305_.pic_hd.jpg" />
        <img class="xieyi" src="@/assets/201606188305_.pic_hd.jpg" />
        <!-- <img class="xieyi" src="@/assets/211606188306_.pic_hd.jpg" /> -->
        <img class="xieyi" src="@/assets/5021659668973_.pic.jpg" />
      </p>
      <!-- <h1> 软著 </h1> -->
      <!-- <p class="content"> -->
        <!-- <img src="@/assets/斯目软著-斯目.jpg" style="width:400px;margin:0 auto;display:block;" /> -->
      <!-- </p> -->
    </div>
</template>
<script>
import { webTitle, company, phone, mail } from '../../utils'

export default {
  name: 'banquan',
  computed: {
    webTitle () {
      return webTitle()
    },
    phone () {
      return phone()
    },
    mail () {
      return mail()
    },
    company () {
      return company()
    }
  }
}
</script>
<style lang="scss" scoped>
.xieyi{
  display: block;
  width:400px;
  margin:0 auto;
}
.content{
  padding:0 40px 0;
  white-space: pre-wrap;
  text-align: left;
}
</style>
